import { frontendURL } from '../../../../helper/URLHelper';
import { LINE_STICKER_PERMISSIONS } from 'dashboard/constants/permissions.js';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const LineStickersIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/line-stickers'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'line_stickers',
          component: LineStickersIndex,
          meta: {
            permissions: ['administrator', LINE_STICKER_PERMISSIONS],
          },
        },
      ],
    },
  ],
};
